import { render, staticRenderFns } from "./ViewPermissions.vue?vue&type=template&id=9486558e&scoped=true"
import script from "./ViewPermissions.vue?vue&type=script&lang=js"
export * from "./ViewPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9486558e",
  null
  
)

export default component.exports